import React, {Component} from "react";
import {connect} from "react-redux";

import "./Introduction.css";

class Introduction extends Component {

  render() {
    const {title, subtitle, children} = this.props;

    return (
      <div className="fow-introduction-block">
        <div className="fow-inner-container">
          <div className="fow-row">
            <div className="fow-col fow-col-1">
              <h1 className="fow-font-title fow-font-size-xl fow-introduction-block-title">{title}</h1>
            </div>
          </div>
          {subtitle &&
            <div className="fow-row">
              <div className="fow-col fow-col-1">
                <h2 className="fow-font-text fow-font-size-md fow-introduction-block-subtitle">{subtitle}</h2>
              </div>
            </div>
          }
          <div className="fow-row fow-md-row-to-col">
            {children}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Introduction);
